import React from "react";
import { useSelector } from "react-redux";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { muiTheme } from "./muiTheme";

interface Props {
  children: React.ReactNode;
}

const ThemeWrapper: React.FC<Props> = ({ children }) => {
  const whitelabelDetails = useSelector(
    (state: any) => state?.AccountReducer?.whitelabelDetails
  );
  const brandColor = whitelabelDetails?.color || "#FF6A00";

  return (
    <ThemeProvider theme={muiTheme(brandColor)}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
